import "./Button.css";
import cn from "classnames";
import type { ComponentProps, ComponentPropsWithRef, FC } from "react";
import type { IconType } from "react-icons";
import { Icon } from "../common/Icon";
import { Loader } from "../common/Loader";

type ButtonVariant =
	| "primary"
	| "social"
	| "secondary"
	| "danger"
	| "link"
	| "ghost";

export interface ButtonProps extends ComponentPropsWithRef<"button"> {
	variant?: ButtonVariant;
	full?: boolean;
	loading?: boolean;
	size?: "sm" | "lg" | "xsm";

	/** Icon **/
	icon?: ComponentProps<typeof Icon>["name"] | IconType;
	iconSize?: ComponentProps<typeof Icon>["size"];
}

export const Button: FC<ButtonProps> = (props) => {
	const {
		icon: _icon,
		onClick: _onClick,
		className,
		size = "md",
		variant = "primary",
		loading = false,
		iconSize,
		full,
		children,
		type = "button",
		disabled = false,
		...rest
	} = props;

	const onClick = disabled ? undefined : _onClick;
	const onDark = variant === "primary" || variant === "danger";

	return (
		<button
			type={type}
			aria-disabled={loading || disabled}
			aria-busy={loading}
			onClick={onClick}
			className={cn(`btn ${size}`, { full }, variant, className)}
			{...rest}
		>
			{loading ? (
				<Loader size="sm" onDark={onDark} />
			) : (
				_icon && <Icon name={_icon} size={iconSize} />
			)}
			{children}
		</button>
	);
};
